var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { property } from 'lit/decorators.js';
import { html, css } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { customElement, PICBase, stringDecoderLC } from '../Internals';
let PICChip = class PICChip extends PICBase {
    constructor() {
        super(...arguments);
        this.density = 'high';
    }
    connectedCallback() {
        super.connectedCallback();
    }
    static get styles() {
        const defaultStyle = css `
        :host{
            --pic-chipIconColor: #666666;
            --pic-chipBGColor: #e0e0e0;
        }
        .chip{
            border: 1px solid rgba(0, 0, 0, 0.12);
            border-radius: 16px;
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            align-items: center;
            white-space: nowrap;
            padding: 8px 8px 8px 12px;
            gap: 8px;
            background-color: var(--pic-chipBGColor); 
        }
        .chip.low{
            height: 32px;
        }
        .chip.medium{
            height: 28px;
        }
        .chip.high{
            height: 24px;
        }
        .chipIcon{
            cursor: pointer;
        }
        .chipIcon::before{
            font-family: "Material Design Icons";
            content: '\u{F0159}';
            width: 18px;
            height: 18px;
            color: var(--pic-chipIconColor);
            cursor: pointer;
        }
        `;
        return css `
            ${super.styles}
            ${defaultStyle}
        `;
    }
    getChipClass() {
        return {
            'chip': true,
            'pic-body2': true,
            ['' + this.density]: true
        };
    }
    handleClick(e) { this.clickAction ? this.clickAction.triggerEvent(e) : ''; }
    handleIconClick(e) { this.iconAction ? this.iconAction.triggerEvent(e) : ''; }
    render() {
        return html `
            <div class=${classMap(this.getChipClass())} @click=${this.handleClick}>
                    <div class="chipHdr">${this.primaryText}</div>
                    <span class="chipText">${this.secondaryText}</span>
                    <div class="chipIcon" @click=${this.handleIconClick}></div>
                </div>
        `;
    }
};
__decorate([
    property()
], PICChip.prototype, "primaryText", void 0);
__decorate([
    property()
], PICChip.prototype, "secondaryText", void 0);
__decorate([
    property({ converter: stringDecoderLC, attribute: 'density' })
], PICChip.prototype, "density", void 0);
PICChip = __decorate([
    customElement('pic-chip')
], PICChip);
export { PICChip };
//# sourceMappingURL=PICChip.js.map